"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OTPPage = void 0;
const react_1 = __importStar(require("react"));
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const doshx_controls_web_1 = require("doshx_controls_web");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const constants_1 = require("../../../constants/constants");
const routes_1 = require("../../../constants/routes");
const main_1 = require("../../../reducers/slices/main");
const verify_otp_1 = require("../../../api/calls/user/verify_otp");
const initialResetPasswordValues = { otp: "" };
const OTPPage = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { forgot_password_id } = (0, react_router_dom_1.useParams)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { isLoading } = (0, react_redux_1.useSelector)((state) => state.userState);
    const [credentials, setCredentials] = (0, react_1.useState)(initialResetPasswordValues);
    const showLoader = () => {
        dispatch((0, main_1.setContentModal)({
            title: "Please Wait...",
            content: react_1.default.createElement(doshx_controls_web_1.CircularLoaderControl, { size: "small" }),
        }));
    };
    const handleResponse = (response) => {
        if (response.success) {
            setCredentials(initialResetPasswordValues);
            dispatch((0, main_1.setContentModal)({ title: "Success", content: react_1.default.createElement(react_1.default.Fragment, null, response.message) }));
            navigate(`${routes_1.WELCOME_ROUTE}${routes_1.RESET_PASSWORD_ROUTE}/${response.content._id}`);
        }
        else
            dispatch((0, main_1.setContentModal)({ title: constants_1.REQUEST_ERROR_TITLE, content: react_1.default.createElement(react_1.default.Fragment, null, response.message) }));
    };
    const _setCredentials = (value) => {
        setCredentials(Object.assign(Object.assign({}, credentials), value));
    };
    const _onSubmit = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!forgot_password_id) {
            dispatch((0, main_1.setContentModal)({ title: constants_1.REQUEST_ERROR_TITLE, content: react_1.default.createElement(react_1.default.Fragment, null, "Invalid session. Please restart the password reset process.") }));
            return;
        }
        const { otp } = credentials;
        showLoader();
        const response = yield (0, verify_otp_1.verify_otp)({
            forgot_password_id,
            otp: credentials.otp,
        });
        handleResponse(response);
    });
    return (react_1.default.createElement("div", { className: "flex flex-col gap-y-4 h-full justify-center w-full lg:w-[700px] py-4 lg:py-0 px-4 lg:px-20" },
        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Enter OTP", size: "3xlarge", textColor: "text-black", bold: true }),
        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "OTP has been emailed to your provided email address please check your inbox", textColor: "text-black", size: "small" }),
        react_1.default.createElement("div", { className: "w-full flex flex-col gap-y-4" },
            react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "OTP", value: credentials.otp, borderColor: "border-borders", onChange: (otp) => {
                    _setCredentials({ otp });
                } }),
            react_1.default.createElement("div", null,
                react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Submit", loading: isLoading, backgroundColor: "bg-primary", onClick: _onSubmit }))),
        react_1.default.createElement("div", { className: "flex flex-row justify-between items-center" },
            react_1.default.createElement(doshx_controls_web_1.LinkButtonControl, { textColor: "text-blue-500", iconColor: "text-blue-500", size: "medium", icon: pro_solid_svg_icons_1.faChevronLeft, label: "Back to sign in", iconSide: "left", onClick: () => {
                    navigate(`${routes_1.WELCOME_ROUTE}${routes_1.LOG_IN_ROUTE}`);
                } }))));
};
exports.OTPPage = OTPPage;
